export const DASHBOARD_ANALYSIS_ORIGINATION = '/dashboard/analysis/origination'
